export default __webpack_public_path__ + "static/media/nUSD.c53623fc.svg";